import { AdAccountModel, AdAccountGroupAdAccountModel } from '@models/types'

type CategoriseAdAccountGroupAdAccountsParams = {
  adAccounts: { [key: number]: AdAccountModel },
  adAccountGroupAdAccounts: AdAccountGroupAdAccountModel[],
}

export const categoriseAdAccountGroupAdAccounts = (params: CategoriseAdAccountGroupAdAccountsParams) => {
  const { adAccounts, adAccountGroupAdAccounts } = params

  const categorised = adAccountGroupAdAccounts.reduce((acc, adAccountGroupAdAccount) => {
    const { adAccountId } = adAccountGroupAdAccount
    const adAccount = adAccounts[adAccountId] || {}
    const { adAccountType } = adAccount

    if (adAccountType?.includes('Facebook')){
      acc.facebook.push(adAccountGroupAdAccount)
    }

    if (adAccountType?.includes('Google')){
      acc.google.push(adAccountGroupAdAccount)
    }

    return acc
  }, { facebook: [] as AdAccountGroupAdAccountModel[], google: [] as AdAccountGroupAdAccountModel[] })

  return categorised
}